const documentConstants = {
  GET_DOCUMENT_INVITATION_DETAILS_REQUEST: 'GET_DOCUMENT_INVITATION_DETAILS_REQUEST',
  GET_DOCUMENT_INVITATION_DETAILS_SUCCESS: 'GET_DOCUMENT_INVITATION_DETAILS_SUCCESS',
  GET_DOCUMENT_INVITATION_DETAILS_FAILURE: 'GET_DOCUMENT_INVITATION_DETAILS_FAILURE',
};

export default documentConstants;
